import {useEffect, useState, useCallback} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const useGetAccountQRGenerate = () => {
	const [fetchResult, fetchRequest, loading] = useFetch()
	const [isRefetch, setIsRefetch] = useState(false)
	const [, setAlert] = useAlertModalAtom()

	const refetch = () => {
		setIsRefetch((prev) => !prev)
	}

	const scanQR = useCallback(() => {
		fetchRequest('GET', `/account/qr-generate`)
	}, [fetchRequest])

	useEffect(() => {
		scanQR()
	}, [isRefetch])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				// Success - QR scan completed
				break
			case 400:
				if (fetchResult?.data?.error_code === 'invalid_qr_token')
					setAlert('유효하지 않은 QR 코드입니다.')
				else if (fetchResult?.data?.error_code === 'expired_qr_token')
					setAlert('만료된 QR 코드입니다.')
				else setAlert('QR 코드 형식이 잘못되었습니다.')
				break
			case 401:
				setAlert('관리자 권한이 필요합니다.')
				break
			case 403:
				setAlert('QR 스캔 권한이 없습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('사용자 또는 이벤트 정보를 찾을 수 없습니다.')
				break
			case 409:
				if (fetchResult?.data?.error_code === 'already_scanned')
					setAlert('이미 스캔된 QR 코드입니다.')
				break
			case 500:
				setAlert('QR 스캔 처리 중 오류가 발생했습니다.')
				break
			default:
				// Handle other status codes
				break
		}
	}, [fetchResult, setAlert])

	return [fetchResult, loading, refetch, scanQR]
}

export default useGetAccountQRGenerate
